import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useSearchParams } from 'react-router-dom';
import { useHasMenu } from '../../../auth/access';
import { SectionTitle } from '../../shared/components';
import ComponentsTab from '../components/setup/ComponentsTab';
import PtSlabsTab from '../components/setup/PtSlabsTab';
import RulesTab from '../components/setup/RulesTab';
import WeeklyOffsTab from '../components/setup/WeeklyOffsTab';

const TABS = [
  { key: 'rules', label: 'Rules' },
  { key: 'components', label: 'Salary components' },
  { key: 'pt', label: 'PT slabs' },
  { key: 'weekly-offs', label: 'Weekly offs' },
] as const;

/**
 * Payroll → Payroll Rules: the office rules, the salary structure and deductions, PT slabs and
 * weekly offs the payroll procedures read. Holidays (HR → Holidays) and each employee's pay
 * (Payroll → Pay Profiles) have pages of their own. Editing is the menu's EDIT action. A change
 * here makes unpaid months recalculate before their next report.
 */
export default function PayrollSetupPage() {
  const canEdit = useHasMenu('payroll.rules', 'EDIT');
  const [params, setParams] = useSearchParams();
  const index = Math.max(0, TABS.findIndex((t) => t.key === params.get('tab')));
  const tab = TABS[index].key;

  return (
    <Stack gap={3}>
      <SectionTitle title='PAYROLL RULES' />
      {!canEdit && <Alert severity='info'>Read only — your role can view the payroll rules but not change them.</Alert>}
      <Tabs
        value={index}
        onChange={(_, i) => setParams({ tab: TABS[i].key }, { replace: true })}
        variant='scrollable'
        scrollButtons='auto'
      >
        {TABS.map((t) => (
          <Tab key={t.key} label={t.label} />
        ))}
      </Tabs>
      {tab === 'rules' && <RulesTab canEdit={canEdit} />}
      {tab === 'components' && <ComponentsTab canEdit={canEdit} />}
      {tab === 'pt' && <PtSlabsTab canEdit={canEdit} />}
      {tab === 'weekly-offs' && <WeeklyOffsTab canEdit={canEdit} />}
    </Stack>
  );
}
